import type { datetime } from '@bringg/types';
import moment, { Moment, unitOfTime } from 'moment-timezone';

import type { RoutesPlannerTask } from '../types';

export const filterValidDatesAndParse = (dates: datetime[]) => {
	return parseDates(dates.filter(Boolean));
};

export const parseDates = (dates: datetime[]) => {
	return dates.map(parseDate);
};
export const parseDate = (date: datetime): number | null => {
	return date ? Date.parse(date) : null;
};

export const getDefaultTimeWindow = () => [moment().startOf('day'), moment().endOf('day')];

export const getStartOfDay = (time: string | Moment, teamTimeZone: string) =>
	moment(time).tz(teamTimeZone).startOf('day').toISOString();

export const findEarliestTaskTime = (tasks: RoutesPlannerTask[]) => {
	const tasksScheduledAt = tasks
		.filter(task => task.priority === 1)
		.map(task => moment(task.way_points[0].scheduled_at));
	return moment.min(tasksScheduledAt);
};

export const getHoursFormat = (date: number | string, timezone: string, hourFormat: string) => {
	return moment(date).tz(timezone).format(hourFormat);
};

const isBetween = (
	date: string | number | Moment,
	ranges: [string | number | Moment, string | number | Moment],
	type?: unitOfTime.StartOf
): boolean => {
	return moment(date).isBetween(ranges[0], ranges[1], type, '[]');
};

const getDateFromUnix = (unixSeconds: number): Moment => {
	return moment(unixSeconds, 'X');
};

const msToDuration = (duration: number, format: string) => {
	const milliseconds: number = Math.floor((duration % 1000) / 100);
	let seconds: string | number = Math.floor((duration / 1000) % 60);
	let minutes: string | number = Math.floor((duration / (1000 * 60)) % 60);
	let hours: string | number = Math.floor(duration / (1000 * 60 * 60));

	hours = hours < 10 ? '0' + hours : hours;
	minutes = minutes < 10 ? '0' + minutes : minutes;
	seconds = seconds < 10 ? '0' + seconds : seconds;

	return format
		.replace('hh', hours.toString())
		.replace('mm', minutes.toString())
		.replace('ss', seconds.toString())
		.replace('ms', milliseconds.toString());
};

export const dateUtils = {
	isBetween,
	getHoursFormat,
	findEarliestTaskTime,
	getStartOfDay,
	getDefaultTimeWindow,
	parseDate,
	parseDates,
	filterValidDatesAndParse,
	getDateFromUnix,
	msToDuration
};
